import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { GenerateProductDescriptionFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface GenerateProductDescriptionFormProps {
  defaultFormValues?: Partial<GenerateProductDescriptionFormValues>;
  children?: React.ReactNode;
}
export const GenerateProductDescriptionForm = ({
  defaultFormValues,
  children,
}: GenerateProductDescriptionFormProps) => {
  const methods = useForm<GenerateProductDescriptionFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
